import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  clearMenuItem,
  loadMenuStart,
  selectMenuItem,
} from '../../redux/modules/order'
import {
  loadOrderCartStart,
  loadEditOrder,
  cancelEditingOrder,
} from '../../redux/modules/cart'
import {
  addPastOrderToCart,
  loadPastOrdersStart,
} from '../../redux/modules/pastorder'
import { loadLocationStart } from '../../redux/modules/location'
import { Article, SpinnerCard } from '../common/Layout'
import ModalPopup from '../common/ModalPopup'
import {
  getMenuInfoForPopularItems,
  getMenuInfoForNewPopularItems,
} from '../../redux/modules/selectors'
import PastOrders from './PastOrders'
import Menu from './Menu'
import ValidationModal from './ValidationModal'
import PersonalizeOrder from '../personalize-order/PersonalizeOrder'
import {
  loadFavoriteStart,
  loadAvailableFavoritesStart,
  addFavoriteStart,
  deleteFavoriteStart,
  loadPopularMenuItems,
} from '../../redux/modules/favorite'
import { SimpleSpinner } from '../common/SimpleSpinner'
import {
  loadFriendsFavorites,
  getFriendsOrdersStart,
} from '../../redux/modules/friends'
import PopularItems from './PopularItems'
import LocationSearchContainer from '../location-search/LocationSearchContainer'
import { loadDeliveryDropoffStart } from '../../redux/modules/delivery'
import { format } from 'date-fns'
import flatten from 'lodash/flatten'
import LoginOrJoin from '../login/LoginOrJoin'
import { pushAnalyticsEvent } from '../../util/gtmUtils'

export class PlaceOrder extends Component {
  // Note: this component will load the data and the sidebar will pick it up from the state
  constructor(props) {
    super(props)
    const { clearMenuItem } = this.props
    clearMenuItem()
  }

  componentDidMount() {
    window && window.scrollTo(0, 0)
    const {
      isAuthenticated,
      loadAvailableFavoritesStart,
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadLocationStart,
      loadMenuStart,
      loadOrderCartStart,
      loadPastOrdersStart,
      loadPopularMenuItems,
    } = this.props

    let {
      match: {
        params: { locationId = 0, dropoffId = 0 },
      },
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId) {
      loadLocationStart(locationId)
      if (dropoffId) {
        loadMenuStart(dropoffId)
        loadDeliveryDropoffStart(dropoffId)
        loadOrderCartStart(dropoffId)
        loadPopularMenuItems()
        if (isAuthenticated) {
          loadPastOrdersStart(dropoffId)
          loadAvailableFavoritesStart()
          loadFavoriteStart()
        }
      }
    }
    pushAnalyticsEvent('Ordering', 'View Menu', undefined, dropoffId)
  }

  componentDidUpdate(prevProps) {
    const {
      deliveryDropoff,
      getFriendsOrdersStart,
      isAuthenticated,
      loadAvailableFavoritesStart,
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadLocationStart,
      loadMenuStart,
      loadOrderCartStart,
      loadPastOrdersStart,
    } = this.props
    let {
      match: {
        params: { locationId = 0, dropoffId = 0 },
      },
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId !== Number(prevProps.match.params.locationId)) {
      loadLocationStart(locationId)
    }
    if (dropoffId !== Number(prevProps.match.params.dropoffId)) {
      loadMenuStart(dropoffId)
      loadDeliveryDropoffStart(dropoffId)
      loadOrderCartStart(dropoffId)
    }
    if (isAuthenticated !== prevProps.isAuthenticated) {
      loadPastOrdersStart(dropoffId)
      loadAvailableFavoritesStart()
      loadFavoriteStart()
      loadMenuStart(dropoffId)
      loadDeliveryDropoffStart(dropoffId)
      loadOrderCartStart(dropoffId)
    }
    if (
      isAuthenticated &&
      deliveryDropoff &&
      prevProps.deliveryDropoff &&
      deliveryDropoff.deliveryDateTime !==
        prevProps.deliveryDropoff.deliveryDateTime
    ) {
      getFriendsOrdersStart(
        format(deliveryDropoff.deliveryDateTime, 'YYYY-MM-DD'),
        locationId,
      )
    }
  }

  componentWillUnmount(props) {
    this.props.cancelEditingOrder()
  }

  render() {
    const {
      addFavoriteStart,
      addPastOrderToCart,
      availableFavorites,
      cancelEditingOrder,
      clearMenuItem,
      deleteFavoriteStart,
      deliveryError,
      favorites,
      hashes,
      isAuthenticated,
      isDeliveryDropoffLoading,
      isEditingFromMenu,
      isEditingOrder,
      isEditingPastOrder,
      isLoadingAvailableFavorites,
      isLoadingFavorites,
      isLoadingFriendsFavorites,
      friendHasOrdered,
      isLoadingNewPopularMenuItems,
      isLocationLoading,
      isMenuLoading,
      isOrderCartLoading,
      isPastOrderListLoading,
      isPastOrderLoading,
      loadEditOrder,
      loadingOrderForEdit,
      menu,
      menuItemForEdit,
      menuItemId,
      menuItemIdsLoading,
      pastOrderError,
      pastOrders,
      selectMenuItem,
      newPopularItems,
      isWebpSupported,
    } = this.props
    let {
      match: {
        params: { dropoffId = 0, locationId = 0 },
      },
    } = this.props
    locationId = Number(locationId)
    dropoffId = Number(dropoffId)
    if (deliveryError) {
      const serverMessage = deliveryError.response
        ? deliveryError.response.data
        : ''
      return (
        <ValidationModal
          locationId={locationId}
          serverMessage={serverMessage}
        />
      )
    }
    return (
      <Article>
        {!isLocationLoading && !locationId && (
          <ModalPopup showCancel="false">
            <LocationSearchContainer />
          </ModalPopup>
        )}
        {isAuthenticated && pastOrders && pastOrders.length > 0 && (
          <SpinnerCard
            spinnerActive={
              isPastOrderListLoading ||
              isOrderCartLoading ||
              isLoadingFavorites ||
              isLoadingFriendsFavorites ||
              isLoadingAvailableFavorites ||
              isMenuLoading ||
              isDeliveryDropoffLoading ||
              isLocationLoading
            }
          >
            <PastOrders
              {...{
                pastOrders,
                pastOrderError,
                isPastOrderLoading,
                addPastOrderToCart,
                addFavoriteStart,
                deleteFavoriteStart,
                editPastOrder: loadEditOrder,
                favorites,
                menuItemIdsLoading,
              }}
            />
          </SpinnerCard>
        )}
        {newPopularItems && newPopularItems.length >= 1 && (
          <SpinnerCard
            spinnerActive={
              isLoadingNewPopularMenuItems ||
              isMenuLoading ||
              isLoadingFavorites
            }
          >
            <PopularItems
              addFavoriteStart={addFavoriteStart}
              availableFavorites={availableFavorites}
              deleteFavoriteStart={deleteFavoriteStart}
              favorites={favorites}
              menuItemIdsLoading={menuItemIdsLoading}
              onSelectMenuItem={itemId => selectMenuItem(itemId)}
              popularItems={newPopularItems}
            />
          </SpinnerCard>
        )}
        {!isMenuLoading && !isAuthenticated && (
          <ModalPopup showCancel={false}>
            <LoginOrJoin
              joinTitle="Register to Order"
              locationId={locationId}
              loginMessage="Login to order and get lunch delivered to your office."
              loginTitle="Login to Order"
              signupMessage="Sign up to order and get lunch delivered to your office."
            />
          </ModalPopup>
        )}
        <SpinnerCard
          spinnerActive={
            isMenuLoading ||
            (isAuthenticated &&
              (isLoadingAvailableFavorites ||
                isLoadingFavorites ||
                isLoadingFriendsFavorites))
          }
        >
          <Menu
            addFavoriteStart={addFavoriteStart}
            availableFavorites={availableFavorites}
            deleteFavoriteStart={deleteFavoriteStart}
            favorites={favorites}
            friendHasOrdered={
              friendHasOrdered &&
              flatten(
                friendHasOrdered.filter(
                  order =>
                    order.dropoffId ===
                    Number(this.props.match.params.dropoffId),
                ),
              )[0]
            }
            hashes={hashes}
            isWebpSupported={isWebpSupported}
            menuData={menu}
            menuItemIdsLoading={menuItemIdsLoading}
            onSelectMenuItem={itemId => selectMenuItem(itemId)}
          />
        </SpinnerCard>
        {menuItemId && !isEditingPastOrder && !isEditingOrder ? (
          <ModalPopup
            id="personalize-modal"
            onCancel={() => {
              clearMenuItem()
            }}
          >
            <PersonalizeOrder
              dropoffId={dropoffId}
              favorites={
                favorites &&
                favorites.filter(favorite => favorite.menuItemId === menuItemId)
              }
              hashes={
                hashes && hashes.filter(hash => hash.menuItemId === menuItemId)
              }
              menuId={menu && menu.menuId}
              menuItemForEdit={menuItemForEdit}
              menuItemId={menuItemId}
            />
          </ModalPopup>
        ) : isEditingPastOrder && menuItemForEdit && isEditingOrder ? (
          <ModalPopup
            id="personalize-modal"
            onCancel={() => {
              cancelEditingOrder()
            }}
          >
            <PersonalizeOrder
              dropoffId={dropoffId}
              favorites={
                favorites &&
                favorites.filter(
                  favorite =>
                    favorite.menuItemId === menuItemForEdit.menuItemId,
                )
              }
              hashes={
                hashes &&
                hashes.filter(
                  hash => hash.menuItemId === menuItemForEdit.menuItemId,
                )
              }
              isEditingFromMenu={isEditingFromMenu}
              isEditingOrder={isEditingOrder}
              menuId={menu.menuId}
              menuItemForEdit={menuItemForEdit}
              menuItemId={menuItemForEdit.menuItemId}
            />
          </ModalPopup>
        ) : loadingOrderForEdit ? (
          <ModalPopup>
            <SimpleSpinner />
          </ModalPopup>
        ) : null}
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const { menu, menuItemId, isMenuLoading, isOrderCartLoading } = state.order
  const { deliveryDropoff, isDeliveryDropoffLoading } = state.delivery
  const {
    pastOrders,
    isPastOrderLoading,
    errorMessage: pastOrderError,
  } = state.pastorder
  const {
    menuItemForEdit,
    isEditingOrder,
    isEditingFromMenu,
    isEditingPastOrder,
    loadingOrderForEdit,
  } = state.cart
  const {
    isLoadingFriendsFavorites,
    isLoadingFriendsOrders,
    friendHasOrdered,
  } = state.friends
  const {
    favorites,
    isLoadingFavorites,
    hashes,
    availableFavorites,
    isLoadingAvailableFavorites,
    isLoadingPopularItems,
    isLoadingNewPopularMenuItems,
    menuItemIdsLoading,
  } = state.favorite
  const { currentUser, isCurrentUserLoading, isAuthenticated } = state.user
  const popularItems = getMenuInfoForPopularItems(state)
  const newPopularItems = getMenuInfoForNewPopularItems(state)
  const { isLocationLoading } = state.location
  const deliveryError = state.delivery.error
  const orderError = state.order.error
  const { isWebpSupported } = state.browser

  return {
    availableFavorites,
    currentUser,
    deliveryDropoff,
    deliveryError,
    favorites,
    friendHasOrdered,
    hashes,
    isAuthenticated,
    isCurrentUserLoading,
    isDeliveryDropoffLoading,
    isEditingFromMenu,
    isEditingOrder,
    isEditingPastOrder,
    isLoadingAvailableFavorites,
    isLoadingFavorites,
    isLoadingFriendsFavorites,
    isLoadingFriendsOrders,
    isLoadingPopularItems,
    isLoadingNewPopularMenuItems,
    isLocationLoading,
    isMenuLoading,
    isOrderCartLoading,
    isPastOrderLoading,
    loadingOrderForEdit,
    menu,
    menuItemForEdit,
    menuItemId,
    menuItemIdsLoading,
    newPopularItems,
    orderError,
    pastOrderError,
    pastOrders,
    popularItems,
    isWebpSupported,
  }
}

const mapDispatchToProps = {
  addFavoriteStart,
  addPastOrderToCart,
  cancelEditingOrder,
  clearMenuItem,
  deleteFavoriteStart,
  loadAvailableFavoritesStart,
  loadDeliveryDropoffStart,
  loadEditOrder,
  loadFavoriteStart,
  loadFriendsFavorites,
  getFriendsOrdersStart,
  loadMenuStart,
  loadLocationStart,
  loadOrderCartStart,
  loadPastOrdersStart,
  selectMenuItem,
  loadPopularMenuItems,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrder)
